import { FC, ReactNode } from "react";
import styles from "./FullScreenLoader.module.scss";
import { useTheme } from "app/shared";

type FullScreenLoaderProps = {
  isLoading: boolean;
  children?: ReactNode;
};

const FullScreenLoader: FC<FullScreenLoaderProps> = ({
  isLoading,
  children,
}) => {
  const { theme } = useTheme();

  return isLoading ? (
    <div
      className={`${styles.loaderContainer} ${
        theme === "dark" ? styles.darkTheme : ""
      }`}
    >
      <div
        className={`${styles.loader} ${
          theme === "dark" ? styles.darkTheme : ""
        }`}
      ></div>
    </div>
  ) : (
    <>{children}</>
  );
};

export default FullScreenLoader;
